export default {
	// Hero
	'Entre no Site': 'Enter site',

	// Navbar
	'Nossa História': 'Our Story',
	Informações: 'Information',
	Presentes: 'Gifts',
	'Cerimônia e Recepção': 'Venue',

	weddingIntro: 'We got married!',

	// Wedding timer
	weddingTimer: {
		title: 'Since we said “I do”',
		years_one: 'year',
		years_other: 'years',
		months_one: 'month',
		months_other: 'months',
		days_one: 'day',
		days_other: 'days',
		hours_one: 'hour',
		hours_other: 'hours',
		minutes_one: 'minute',
		minutes_other: 'minutes',
		seconds_one: 'second',
		seconds_other: 'seconds',
	},

	// Our Story
	ourStory: {
		part1:
			"In 2015, we met on the first day of college. A bald Elton 👨‍ and a thais who hasn't changed a bit (his words) had their first contact.",
		part2:
			'2 years later, between one conversation and another, always about college work or about Canada 🇨🇦, feelings started to develop. For Elton it was simple, this was the person he dreamed he would marry. Thais, on the other hand, had no idea of everything that God had prepared for her.',
		part3:
			'Thanks to a good friend who pushed them together, these two shy programmers (who developed this site together 🤓) finally got close.',
		part4:
			'And so, after 6 months of prayer and a lot of talking, we had our first kiss and started dating in March 2017 🎉.',
		part5:
			"It didn't take long for it to become clear that God had chosen us for each other, our love was growing. But as time went by, difficult moments also came by. With a lot of patience, affection and God's grace, no hard moments were able to separate us, our love only strengthened and we fell in love with each other even more, we became best friends. We were very blessed on our journey together, the great dream of going to Canada that we always shared, came true. All the struggle, effort and work paid off. In February 2022, our dream to get engaged finally came true 💍, and in July we got married legally.",
		part6:
			"Today, we are organizing up our first place (aka a mini apartment in Toronto) together, cooking together, and soon we'll be officially married. The month we chose for our big day is special, because it's when we celebrate 6 years together and we celebrate one more year of Elton's life. We're very excited for the arrival of this day and very happy to be able to celebrate with so many friends and family, we hope you can join us! ❤️",
	},

	// Information
	Traje: 'Dress Code',
	'Folha de bordo': 'Maple leaf',
	'Para os Homens': 'Men',
	'O uso da gravata é opcional.': 'The use of a tie is optional.',
	'Para as Mulheres': 'Women',
	'Recomendamos um look que combine com a leveza do campo, e o uso de sapatos com salto grosso devido ao terreno do local.':
		'We recommend a light and airy outfit that goes with an open field space, and the use of thick heels due to the local terrain.',
	womenWarning:
		'Avoid <1>thin heels</1>, and dresses on the shades of <1>white</1>, <1>off-white</1>, <1>lilac</1>, and <1>lavender</1>',
	'Compartilhe o Amor': 'Share the Love',
	'Seja nosso fotógrafo de honra, e se utilizar o Instagram não esqueça de usar a nossa hashtag':
		"Be our honorary photographer, and if you use Instagram don't forget to use our hashtag",
	'e de nos marcar': 'and to tag us',
	'para que possamos ver todos os momentos registrados por vocês!':
		'so we can see all the moments recorded by you!',
	'Pedidos dos noivos': 'Bride and Groom requests',
	'Por favor confirme sua presença: O cerimonial entrará em contato para confirmar sua presença':
		'Please RSVP',
	'Por favor não se atrase para a cerimônia':
		"Please don't be late to the ceremony",

	// Gifts
	'Clique aqui para acessar a nossa lista de presentes':
		'Click here to access our gift registry (🇧🇷)',
	giftContent:
		'Your presence is our greatest gift! However, if you also want to give us something else, we created a virtual gift registry with some things and also quotas for our honeymoon in Mexico 🇲🇽 🏖️. If you prefer to do a bank transfer directly, we also have PIX (🇧🇷) and Interac (🇨🇦) options. Thank you in advance!',
	'Chave PIX': 'PIX Key',

	// Venue
	'Casamento Thais & Elton': 'Thais & Elton Wedding',
	'Adicionar ao Calendário': 'Add to Calendar',
	'Venha comemorar essa data especial conosco!':
		'Come celebrate this special date with us!',
	Data: 'Date',
	Hora: 'Hour',
	'Local da Cerimônia e Recepção': 'Venue Address',
	Brasil: 'Brazil',
}
